import { defineMessages } from 'react-intl';

export const carouselHeroMessages = defineMessages({
	ariaLabel: {
		id: 'ConfluenceSoftwarePage.v4.CarouselHero.AriaLabel',
		defaultMessage: 'A display of various confluence features',
		description: 'Aria label for the carousel section',
	},
});
